import { FC } from "react";
import { useTranslation } from "next-i18next";

interface UnprocessableEntityProps {
  error?: string;
  errors?: { [key: string]: string[] };
}

const UnprocessableEntity: FC<UnprocessableEntityProps> = ({
  error,
  errors,
}) => {
  const { t } = useTranslation("validation");

  if (error) {
    return <p>{error}</p>;
  }

  if (errors) {
    return (
      <ul>
        {Object.entries(errors).map(([key, value]) => (
          <li key={key}>{value[0]}</li>
        ))}
      </ul>
    );
  }

  return <p>{t("422.generic-message")}</p>;
};

export default UnprocessableEntity;
